import type { ArdoqId } from '@ardoq/api-types';
import type { LoadedGraphWithViewpointMode } from '@ardoq/data-model';
import { componentUtils, enhancedScopeDataOperations } from '@ardoq/scope-data';
import { uniq } from 'lodash';

const toComponentTypeName =
  (loadedGraph: LoadedGraphWithViewpointMode) =>
  (componentId: ArdoqId): string[] => {
    const { scopeData } = loadedGraph;
    if (!enhancedScopeDataOperations.getComponent(scopeData, componentId)) {
      return [];
    }
    const componentType =
      enhancedScopeDataOperations.getComponentTypeByComponentId(
        scopeData,
        componentId
      );
    return componentType ? [componentType.name] : [];
  };

export const collectComponentTypeNamesWithAncestors = (
  loadedGraph: LoadedGraphWithViewpointMode
): string[] =>
  uniq(
    componentUtils
      .getComponentIdsWithAncestors(
        loadedGraph.scopeData,
        loadedGraph.scopeComponentIds
      )
      .flatMap(toComponentTypeName(loadedGraph))
  );
